import { StyleSheet } from "@react-pdf/renderer";

export const styles = StyleSheet.create({
  body: {
    paddingHorizontal: 35,
  },
  twoColumnGrid: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginHorizontal: -10,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    margin: 1,
    paddingTop: 20,
    paddingBottom: 10,
  },
  headerImageTitleContainer: {
    display: "flex",
    flexDirection: "column",
  },
  headerImage: {
    height: "auto",
    width: 100,
  },
  footer: {
    position: "absolute",
    fontSize: 7,
    bottom: 10,
    left: 0,
    right: 0,
    color: "grey",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  addressText: {
    fontSize: 7,
    marginTop: 9,
    color: "rgba(68, 68, 68, 0.8)",
  },
  blackText: {
    color: "#000000",
  },
  grayText: {
    color: "#444444",
  },
  blueText: {
    color: "#01457C",
  },
  whiteText: {
    color: "#FFFFFF",
  },
  redText: {
    color: "#B91C1C",
  },
  greenText: {
    color: "#15803D",
  },

  text: {
    fontFamily: "Roboto",
    color: "#2D3748",
    fontSize: 7.5,
    position: "relative",
    lineHeight: 1.2,
  },
  textSmMd: {
    fontFamily: "Roboto",
    color: "#2D3748",
    fontSize: 8.5,
    position: "relative",
    lineHeight: 1.2,
  },
  textMd: {
    color: "#2D3748",
    fontFamily: "Roboto",
    fontSize: 10,
  },
  textLg: {
    fontFamily: "Roboto",
    fontSize: 12,
  },
  textSm: {
    fontFamily: "Roboto",
    fontSize: 7.5,
    lineHeight: 1.25,
  },
  textSmBlock: {
    fontFamily: "Roboto",
    fontWeight: 700,
    fontSize: 8,
    textTransform: "uppercase",
    letterSpacing: "0.5",
  },
  table: {
    width: "100%",
  },
  tableRow: {
    display: "flex",
    flexDirection: "row",
    paddingVertical: 3,
  },
  tableRowNoBorder: {
    display: "flex",
    flexDirection: "row",
    paddingVertical: 3,
  },
  tableCell: {
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
  },
  tableCell2: {
    width: "35%",
  },
  tableCell3: {
    width: "30%",
  },
  tableStripe: {
    position: "absolute",
    top: -8,
    right: -30,
    height: "83vh",
    width: "110%",
    borderRadius: 3,
    backgroundColor: "#f2f6fa",
  },
  textAlignRight: {
    alignSelf: "flex-end",
    textAlign: "right",
  },
  textAlignCenter: {
    alignSelf: "center",
  },
  superscript: {
    fontSize: 6,
    marginLeft: 2,
  },
  nameHeader: {
    color: "#01457C",
    fontFamily: "Roboto",
    fontWeight: 700,
    fontSize: 7.5,
    textTransform: "uppercase",
  },
  infoMedium: {
    color: "#000000",
    fontWeight: 500,
    fontSize: 7.5,
  },
  info: {
    color: "#444444",
    fontWeight: 400,
    fontSize: 7.5,
  },
  promotionText: {
    color: "#01457C",
    fontWeight: 600,
  },
});
